export const COUNT_TO_FIND_DUPLICATES = 10;
